import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type EventFormValues = {
  id?: string;
  type: string | null;
  psVet: string | null;
  startDate: string | null;
  endDate: string | null;
  coveringSite: string;
  description: string;
  enteredBy: string;
  psEmbryologist: string | null;
  attendees: string[];
};

interface ModalState {
  open: boolean;
  mode: 'create' | 'edit';
  initialValues: EventFormValues | null;
}

const initialState: ModalState = {
  open: false,
  mode: 'create',
  initialValues: null,
};

const createEventModalSlice = createSlice({
  name: 'createEventModal',
  initialState,
  reducers: {
    openForCreate: (
      state,
      action: PayloadAction<Partial<EventFormValues> | undefined>,
    ) => {
      state.open = true;
      state.mode = 'create';
      state.initialValues = {
        type: null,
        psVet: null,
        startDate: null,
        endDate: null,
        coveringSite: '',
        description: '',
        enteredBy: '',
        psEmbryologist: null,
        attendees: [],
        ...action.payload,
      };
    },
    openForEdit: (state, action: PayloadAction<EventFormValues>) => {
      state.open = true;
      state.mode = 'edit';
      state.initialValues = action.payload;
    },
    closeModal: (state) => {
      state.open = false;
      state.initialValues = null;
    },
  },
});

export const { openForCreate, openForEdit, closeModal } =
  createEventModalSlice.actions;

export default createEventModalSlice.reducer;
